export const GrainOverlay = () => <div className="grain" aria-hidden="true" />;
